module.exports = __webpack_public_path__ + "img/index6.bda1e653.png";